import moment from "moment";
import { isUndefined } from "lodash";

export function formatDateRange(dates) {
  if (!dates || dates.length === 0) {
    return "No dates selected";
  }

  const sortedDates = dates.map((d) => new Date(d)).sort((a, b) => a - b);

  const startDate = moment(sortedDates[0]).format("MMM D, YYYY");
  const endDate = moment(sortedDates[sortedDates.length - 1]).format(
    "MMM D, YYYY",
  );

  return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
}

export function formatConsecutiveDateRanges(dates) {
  if (!dates || dates.length === 0) {
    return "";
  }

  const sortedDates = dates
    .map((d) => moment(d))
    .sort((a, b) => a.valueOf() - b.valueOf());

  const ranges = [];
  if (sortedDates.length > 0) {
    let rangeStart = sortedDates[0];
    let rangeEnd = sortedDates[0];

    for (let i = 1; i < sortedDates.length; i++) {
      const date = sortedDates[i];
      if (date.diff(rangeEnd, "days") === 1) {
        rangeEnd = date;
      } else {
        if (rangeStart.isSame(rangeEnd, "day")) {
          ranges.push(rangeStart.format("MMM D, YYYY"));
        } else if (rangeStart.isSame(rangeEnd, "month")) {
          ranges.push(
            `${rangeStart.format("MMM D")} - ${rangeEnd.format("D, YYYY")}`,
          );
        } else {
          ranges.push(
            `${rangeStart.format("MMM D")} - ${rangeEnd.format("MMM D, YYYY")}`,
          );
        }
        rangeStart = date;
        rangeEnd = date;
      }
    }

    // Push the last range
    if (rangeStart.isSame(rangeEnd, "day")) {
      ranges.push(rangeStart.format("MMM D, YYYY"));
    } else if (rangeStart.isSame(rangeEnd, "month")) {
      ranges.push(
        `${rangeStart.format("MMM D")} - ${rangeEnd.format("D, YYYY")}`,
      );
    } else {
      ranges.push(
        `${rangeStart.format("MMM D")} - ${rangeEnd.format("MMM D, YYYY")}`,
      );
    }
  }

  return ranges.join(", ");
}

export const generateBookingSlots = (startTime, endTime, interval) => {
  if (!startTime || !endTime || !interval || interval <= 0) {
    return [];
  }

  const slots = [];
  let current = moment(startTime, "HH:mm");
  const end = moment(endTime, "HH:mm");

  while (current.clone().add(interval, "minutes").isSameOrBefore(end)) {
    const slotEnd = current.clone().add(interval, "minutes");
    slots.push(`${current.format("hh:mm A")} - ${slotEnd.format("hh:mm A")}`);
    current = slotEnd;
  }

  return slots;
};

export const getCapacityLabel = (item) => {
  const { minimum, maximum } = item;
  if (isUndefined(minimum) || isUndefined(maximum)) {
    return `capacity undefined`;
  } else {
    return `${minimum} to ${maximum} pax`;
  }
};
